var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticStyle: { width: "100%" },
    attrs: {
      items: _vm.tests,
      "hide-default-footer": "",
      "hide-default-header": "",
      "disable-pagination": "",
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c(
              "v-card",
              {
                staticClass: "mb-2",
                attrs: { outlined: "", color: "darken-1", elevation: "0" },
              },
              [
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "ml-2 mt-2",
                        attrs: {
                          color: item.id == _vm.active ? "green" : "red",
                          size: "15",
                        },
                      },
                      [_vm._v("mdi-checkbox-blank-circle")]
                    ),
                    _c(
                      "v-card-title",
                      { staticClass: "black--text ma-0 pa-0 ml-2 mt-2" },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-2",
                        attrs: { icon: "", color: "blue" },
                        on: {
                          click: function ($event) {
                            return _vm.onPressEditTest(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-2",
                        attrs: {
                          icon: "",
                          color: "red",
                          loading: _vm.deleting[item.id],
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onPressDeleteTest(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-delete")])],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-2 mr-2",
                        attrs: {
                          icon: "",
                          color: item.id == _vm.active ? "green" : "grey",
                          loading: _vm.activating[item.id],
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onPressActivate(item)
                          },
                        },
                      },
                      [
                        item.id == _vm.active
                          ? _c("v-icon", { attrs: { size: "30" } }, [
                              _vm._v("mdi-toggle-switch"),
                            ])
                          : _c("v-icon", { attrs: { size: "30" } }, [
                              _vm._v("mdi-toggle-switch-off"),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0" },
                  [
                    _c(
                      "v-card-text",
                      { staticClass: "grey--text ma-0 pa-0 ml-3 mr-3" },
                      [_vm._v(_vm._s(item.message))]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0 ml-3 mb-2 mt-2" },
                  [
                    _vm._l(_vm.sortByName(item), function (aud) {
                      return [
                        _c(
                          "v-card",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              outlined: "",
                              elevation: "0",
                              width: aud.percent + "%",
                              color:
                                item.id == _vm.active ? aud.getColor() : "grey",
                            },
                          },
                          [
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-card-text",
                                  {
                                    staticClass:
                                      "white--text ma-0 pa-0 ml-1 font-weight-black",
                                    staticStyle: { "margin-top": "-12px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(aud.name.toUpperCase()) +
                                        " (" +
                                        _vm._s(aud.percent) +
                                        "%)"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-card-text",
                                  {
                                    staticClass: "white--text ma-0 pa-0 ml-1",
                                    staticStyle: { "font-size": "12px" },
                                  },
                                  [_vm._v(_vm._s(_vm.getUsers(item, aud)))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-card",
                                  {
                                    attrs: {
                                      color: _vm.shadeColor(
                                        item.id == _vm.active
                                          ? aud.getColor()
                                          : "#9E9E9E",
                                        -20
                                      ),
                                      width: "100%",
                                      height: "5px",
                                      elevation: "0",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-card-actions",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          margin: "0px 1px 0px 1px!important",
                                        },
                                      },
                                      [
                                        _c("v-card", {
                                          attrs: {
                                            color: "white",
                                            width: _vm.getUsersPercent(
                                              item,
                                              aud
                                            ),
                                            height: "5px",
                                            elevation: "0",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                ),
                _c(
                  "v-card-actions",
                  { staticClass: "ma-0 pa-0 mb-0" },
                  [
                    _c(
                      "v-chip",
                      {
                        staticClass: "ml-3 mb-2 white--text",
                        attrs: { label: "", color: "blue" },
                      },
                      [
                        _vm._v(
                          _vm._s(item.users != 0 ? item.users : "All") +
                            " users"
                        ),
                      ]
                    ),
                    _c(
                      "v-chip",
                      {
                        staticClass: "ml-3 mb-2",
                        attrs: { outlined: "", label: "", color: "grey" },
                      },
                      [
                        _vm._v(
                          "created: " +
                            _vm._s(
                              _vm._f("formatDate")(Number(item.id) / 1000000000)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }